// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Swiper from "swiper";
import Swiper$1 from "swiper";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Os$Showside from "./Os.bs.js";
import * as DOMUtils$Showside from "./DOMUtils.bs.js";
import * as ReactDOMUtils$Showside from "./ReactDOMUtils.bs.js";
import * as LocationConfig$Showside from "./LocationConfig.bs.js";
import * as SwiperReact from "swiper/react/swiper-react";
import * as ScrollRestoration$Showside from "./ScrollRestoration.bs.js";
var SwiperCore = {};
Swiper$1.use(Belt_Array.concat([Swiper.Keyboard, Swiper.Scrollbar, Swiper.Navigation, Swiper.Pagination, Swiper.Mousewheel, Swiper.EffectFade, Swiper.EffectCoverflow, Swiper.FreeMode, Swiper.Grid, Swiper.Autoplay], Os$Showside.getOS(undefined) !== /* IOS */3 ? [Swiper.A11y] : []));
var Swiper$2 = {};
var SwiperSlide = {};
function slot(name) {
  return React.cloneElement(React.createElement("div", undefined), {
    slot: name
  });
}
function slidesPerViewToString(slidesPerView) {
  if (slidesPerView) {
    return slidesPerView._0.toString();
  } else {
    return "auto";
  }
}
function defRender(a, param) {
  return a;
}
function Slider(Props) {
  var items = Props.items;
  var spaceBetweenOpt = Props.spaceBetween;
  var initialSlideOpt = Props.initialSlide;
  var slidesOffsetBeforeOpt = Props.slidesOffsetBefore;
  var slidesOffsetAfterOpt = Props.slidesOffsetAfter;
  var slidesPerViewOpt = Props.slidesPerView;
  var slidesPerGroupOpt = Props.slidesPerGroup;
  var slidesPerColumnOpt = Props.slidesPerColumn;
  var directionOpt = Props.direction;
  var enableFreeModeOpt = Props.enableFreeMode;
  var freeModeSticky = Props.freeModeSticky;
  var freeModeMomentumVelocityRatioOpt = Props.freeModeMomentumVelocityRatio;
  var centeredSlidesOpt = Props.centeredSlides;
  var centeredSlidesBoundsOpt = Props.centeredSlidesBounds;
  var centerInsufficientSlidesOpt = Props.centerInsufficientSlides;
  var effect = Props.effect;
  var slideToIndexOpt = Props.slideToIndex;
  var slideToIndexRef = Props.slideToIndexRef;
  var allowTouchMoveOpt = Props.allowTouchMove;
  var enableScrollbarOpt = Props.enableScrollbar;
  var hideScrollbarOpt = Props.hideScrollbar;
  var dragScrollbarOpt = Props.dragScrollbar;
  var enableKeyboardOpt = Props.enableKeyboard;
  var enableNavigationOpt = Props.enableNavigation;
  var enablePaginationOpt = Props.enablePagination;
  var enableMousewheelOpt = Props.enableMousewheel;
  var enableAutoplayOpt = Props.enableAutoplay;
  var loopOpt = Props.loop;
  var duplicateSlidesForLoopingAutoplayOpt = Props.duplicateSlidesForLoopingAutoplay;
  var loopedSlides = Props.loopedSlides;
  var className = Props.className;
  var nested = Props.nested;
  var onSlideChange = Props.onSlideChange;
  var restorationId = Props.restorationId;
  var zoom = Props.zoom;
  var threshold = Props.threshold;
  var resizeObserver = Props.resizeObserver;
  var cssMode = Props.cssMode;
  var keepDisabledButtonsVisibleOpt = Props.keepDisabledButtonsVisible;
  var width = Props.width;
  var enabledOpt = Props.enabled;
  var coverflowEffect = Props.coverflowEffect;
  var autoplayDelayOpt = Props.autoplayDelay;
  var transitionOpt = Props.transition;
  var transitionSpeedOpt = Props.transitionSpeed;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var onInit = Props.onInit;
  var spaceBetween = spaceBetweenOpt !== undefined ? spaceBetweenOpt : 0;
  var initialSlide = initialSlideOpt !== undefined ? initialSlideOpt : 0;
  var slidesOffsetBefore = slidesOffsetBeforeOpt !== undefined ? slidesOffsetBeforeOpt : 0;
  var slidesOffsetAfter = slidesOffsetAfterOpt !== undefined ? slidesOffsetAfterOpt : 0;
  var slidesPerView = slidesPerViewOpt !== undefined ? slidesPerViewOpt : /* Auto */0;
  var slidesPerGroup = slidesPerGroupOpt !== undefined ? slidesPerGroupOpt : 1;
  var slidesPerColumn = slidesPerColumnOpt !== undefined ? slidesPerColumnOpt : 1;
  var direction = directionOpt !== undefined ? directionOpt : "horizontal";
  var enableFreeMode = enableFreeModeOpt !== undefined ? enableFreeModeOpt : false;
  var freeModeMomentumVelocityRatio = freeModeMomentumVelocityRatioOpt !== undefined ? freeModeMomentumVelocityRatioOpt : 1.0;
  var centeredSlides = centeredSlidesOpt !== undefined ? centeredSlidesOpt : false;
  var centeredSlidesBounds = centeredSlidesBoundsOpt !== undefined ? centeredSlidesBoundsOpt : false;
  var centerInsufficientSlides = centerInsufficientSlidesOpt !== undefined ? centerInsufficientSlidesOpt : false;
  var slideToIndex = slideToIndexOpt !== undefined ? slideToIndexOpt : -1;
  var allowTouchMove = allowTouchMoveOpt !== undefined ? allowTouchMoveOpt : true;
  var enableScrollbar = enableScrollbarOpt !== undefined ? enableScrollbarOpt : false;
  var hideScrollbar = hideScrollbarOpt !== undefined ? hideScrollbarOpt : false;
  var dragScrollbar = dragScrollbarOpt !== undefined ? dragScrollbarOpt : false;
  var enableKeyboard = enableKeyboardOpt !== undefined ? enableKeyboardOpt : false;
  var enableNavigation = enableNavigationOpt !== undefined ? enableNavigationOpt : false;
  var enablePagination = enablePaginationOpt !== undefined ? enablePaginationOpt : false;
  var enableMousewheel = enableMousewheelOpt !== undefined ? enableMousewheelOpt : false;
  var enableAutoplay = enableAutoplayOpt !== undefined ? enableAutoplayOpt : false;
  var loop = loopOpt !== undefined ? loopOpt : false;
  var duplicateSlidesForLoopingAutoplay = duplicateSlidesForLoopingAutoplayOpt !== undefined ? duplicateSlidesForLoopingAutoplayOpt : false;
  var keepDisabledButtonsVisible = keepDisabledButtonsVisibleOpt !== undefined ? keepDisabledButtonsVisibleOpt : false;
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var autoplayDelay = autoplayDelayOpt !== undefined ? autoplayDelayOpt : 3000;
  var transition = transitionOpt !== undefined ? transitionOpt : "ease";
  var transitionSpeed = transitionSpeedOpt !== undefined ? transitionSpeedOpt : 300;
  var ref = React.useRef(null);
  var match = LocationConfig$Showside.use(undefined);
  var namespace = match.namespace;
  var match$1 = React.useState(function () {});
  var setController = match$1[1];
  var controller = match$1[0];
  var cssMode$1 = Belt_Option.getWithDefault(cssMode, Os$Showside.isSafariVersion__16_3(undefined));
  var restoration = ScrollRestoration$Showside.useScrollRestoration(restorationId);
  React.useEffect(function () {
    performance.mark && performance.mark('Swiper rendered');
  }, []);
  React.useEffect(function () {
    var withinScrollLock = function (lock) {
      return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(ref.current), function (el) {
        return DOMUtils$Showside.isDescendent(el, lock.element);
      }), false);
    };
    var restoreFromPosition = function (controller, position) {
      var n = restoration.position;
      if (typeof n === "number") {
        controller.slideTo(initialSlide, 0);
        return;
      }
      if (n.TAG === /* Pixels */0) {
        return;
      }
      var n$1 = n._0;
      if (controller.activeIndex !== n$1) {
        controller.slideTo(n$1, 0);
        return;
      }
    };
    if (controller !== undefined) {
      var lock = restoration.lock;
      if (lock !== undefined && withinScrollLock(lock)) {
        Belt_Option.map(restorationId, function (restorationId) {
          var arg = {
            TAG: /* Index */1,
            _0: controller.activeIndex
          };
          return function (param) {
            return ScrollRestoration$Showside.setCurrentScroll(param, restorationId, arg);
          };
        });
      } else {
        restoreFromPosition(controller, restoration.position);
      }
    }
  }, [ref.current, restoration, controller, initialSlide, ScrollRestoration$Showside.setCurrentScroll]);
  var onSlideChangeWrapper = React.useCallback(function ($$event) {
    var activeIndex = $$event.activeIndex;
    if (activeIndex !== undefined) {
      Belt_Option.forEach(restorationId, function (restorationId) {
        ScrollRestoration$Showside.setCurrentScroll(namespace, restorationId, {
          TAG: /* Index */1,
          _0: activeIndex
        });
      });
    }
    Belt_Option.forEach(onSlideChange, function (fn) {
      Curry._1(fn, $$event);
    });
  }, [restorationId, onSlideChange]);
  React.useEffect(function () {
    if (controller !== undefined) {
      controller.update();
    }
  });
  React.useEffect(function () {
    if (controller !== undefined && slideToIndex >= 0) {
      controller.slideTo(slideToIndex, transitionSpeed);
    }
  }, [controller, slideToIndex]);
  if (slideToIndexRef !== undefined) {
    slideToIndexRef.current = function (index) {
      if (controller !== undefined && index >= 0) {
        controller.slideTo(index, transitionSpeed);
        return;
      }
    };
  }
  React.useEffect(function () {
    if (controller !== undefined) {
      if (enabled) {
        controller.enable();
      } else {
        controller.disable();
      }
    }
    return function (param) {
      if (slideToIndexRef !== undefined) {
        slideToIndexRef.current = function (param) {};
        return;
      }
    };
  }, [enabled]);
  var style = React.useMemo(function () {
    return {
      width: "auto"
    };
  }, []);
  var items$1 = React.useMemo(function () {
    var slidesPerViewNum = slidesPerView ? slidesPerView._0 : 1;
    if (loop && enableAutoplay && duplicateSlidesForLoopingAutoplay && slidesPerViewNum * 2 > items.length) {
      return Belt_Array.concat(items, items);
    } else {
      return items;
    }
  }, [items, loop, enableAutoplay, duplicateSlidesForLoopingAutoplay, slidesPerView]);
  var slides = Belt_Array.mapWithIndex(Belt_Array.keep(items$1, function (el) {
    return Caml_obj.notequal(el, null);
  }), function (idx, item) {
    return React.createElement(SwiperReact.SwiperSlide, {
      style: style,
      children: item
    });
  });
  var scrollbar = enableScrollbar ? {
    enabled: true,
    draggable: dragScrollbar,
    hide: hideScrollbar
  } : undefined;
  var navigation = React.useMemo(function () {
    if (enableNavigation) {
      return {
        enabled: true,
        disabledClass: keepDisabledButtonsVisible ? "swiper-button-disabled swiper-button-disabled-remain-visible" : "swiper-button-disabled"
      };
    }
  }, [enableNavigation, keepDisabledButtonsVisible]);
  var pagination = React.useMemo(function () {
    if (enablePagination) {
      return {
        clickable: true,
        dynamicBullets: items$1.length > 1
      };
    }
  }, [enablePagination, items$1.length]);
  var autoplay = React.useMemo(function () {
    if (enableAutoplay) {
      return {
        enabled: true,
        delay: autoplayDelay
      };
    }
  }, [enableAutoplay, autoplayDelay]);
  var keyboard = enableKeyboard ? {
    enabled: true,
    onlyInViewport: true
  } : undefined;
  var mousewheel = React.useMemo(function () {
    if (enableMousewheel) {
      return {
        enabled: true,
        forceToAxis: true
      };
    }
  }, [enableMousewheel]);
  var freeMode = React.useMemo(function () {
    if (enableFreeMode) {
      return {
        enabled: true,
        momentumVelocityRatio: freeModeMomentumVelocityRatio,
        sticky: freeModeSticky
      };
    }
  }, [enableFreeMode, freeModeSticky, freeModeMomentumVelocityRatio]);
  var grid = React.useMemo(function () {
    if (slidesPerColumn !== 1) {
      return {
        rows: slidesPerColumn,
        fill: "row"
      };
    }
  }, [slidesPerColumn]);
  var fadeEffect = React.useMemo(function () {
    if (effect === "fade") {
      return {
        crossFade: true
      };
    }
  }, [effect]);
  var a11y = React.useMemo(function () {
    return {
      enabled: true
    };
  }, []);
  var onImagesReady = React.useCallback(function (param) {
    if (controller !== undefined) {
      controller.scrollbar.updateSize();
      return;
    }
  }, [controller]);
  var onSwiper = React.useCallback(function (controller) {
    Curry._1(setController, function (param) {
      return controller;
    });
    controller.slideTo(initialSlide, 0);
  }, [initialSlide, setController]);
  var style$1 = React.useMemo(function () {
    return Object.assign({}, {
      paddingRight: "" + String(slidesOffsetAfter) + "px",
      paddingLeft: "" + String(slidesOffsetBefore) + "px",
      zIndex: "0"
    }, {
      "--qvtw-transition-timing-function": transition
    });
  }, [transition, slidesOffsetBefore, slidesOffsetAfter]);
  var key = effect !== undefined ? effect : "none";
  var key$1 = key + "-" + slidesPerViewToString(slidesPerView) + "-" + String(slidesPerColumn) + "-" + String(slidesPerGroup) + "-" + Pervasives.string_of_bool(loop) + "-" + Belt_Option.mapWithDefault(loopedSlides, "", function (f) {
    return String(f);
  }) + "-" + Pervasives.string_of_bool(enableScrollbar) + "-" + Pervasives.string_of_bool(enablePagination) + "-" + Pervasives.string_of_bool(enableNavigation) + "-" + Pervasives.string_of_bool(enableAutoplay) + "-" + String(autoplayDelay) + "-" + String(spaceBetween);
  var tmp = {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    style: style$1,
    observer: false,
    observeParents: false,
    observeSlideChildren: false,
    children: slides,
    onSwiper: onSwiper,
    spaceBetween: spaceBetween,
    slidesPerView: slidesPerViewToString(slidesPerView),
    slidesPerGroup: slidesPerGroup,
    allowTouchMove: allowTouchMove,
    centerInsufficientSlides: centerInsufficientSlides,
    centeredSlides: centeredSlides,
    centeredSlidesBounds: centeredSlidesBounds,
    cssMode: cssMode$1,
    edgeSwipeDetection: true,
    direction: direction,
    a11y: a11y,
    onImagesReady: onImagesReady,
    onSlideChange: onSlideChangeWrapper,
    simulateTouch: true,
    touchStartPreventDefault: false,
    touchMoveStopPropagation: true,
    enabled: enabled,
    loop: loop,
    speed: transitionSpeed,
    key: key$1
  };
  if (resizeObserver !== undefined) {
    tmp.resizeObserver = resizeObserver;
  }
  if (onInit !== undefined) {
    tmp.onInit = Caml_option.valFromOption(onInit);
  }
  if (effect !== undefined) {
    tmp.effect = Caml_option.valFromOption(effect);
  }
  if (className !== undefined) {
    tmp.className = className;
  }
  if (threshold !== undefined) {
    tmp.threshold = threshold;
  }
  if (scrollbar !== undefined) {
    tmp.scrollbar = Caml_option.valFromOption(scrollbar);
  }
  if (keyboard !== undefined) {
    tmp.keyboard = Caml_option.valFromOption(keyboard);
  }
  if (navigation !== undefined) {
    tmp.navigation = Caml_option.valFromOption(navigation);
  }
  if (pagination !== undefined) {
    tmp.pagination = Caml_option.valFromOption(pagination);
  }
  if (mousewheel !== undefined) {
    tmp.mousewheel = Caml_option.valFromOption(mousewheel);
  }
  if (freeMode !== undefined) {
    tmp.freeMode = Caml_option.valFromOption(freeMode);
  }
  if (nested !== undefined) {
    tmp.nested = nested;
  }
  if (zoom !== undefined) {
    tmp.zoom = zoom;
  }
  if (width !== undefined) {
    tmp.width = width;
  }
  if (coverflowEffect !== undefined) {
    tmp.coverflowEffect = Caml_option.valFromOption(coverflowEffect);
  }
  if (fadeEffect !== undefined) {
    tmp.fadeEffect = Caml_option.valFromOption(fadeEffect);
  }
  if (autoplay !== undefined) {
    tmp.autoplay = Caml_option.valFromOption(autoplay);
  }
  if (grid !== undefined) {
    tmp.grid = Caml_option.valFromOption(grid);
  }
  if (loopedSlides !== undefined) {
    tmp.loopedSlides = loopedSlides;
  }
  if (dataTestId !== undefined) {
    tmp["data-testid"] = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp["data-id"] = dataId;
  }
  return React.createElement(SwiperReact.Swiper, tmp);
}
Slider.displayName = "Slider";
var make = React.memo(Slider);
var $$default = make;
export { SwiperCore, Swiper$2 as Swiper, SwiperSlide, slot, slidesPerViewToString, defRender, make, $$default, $$default as default };
/*  Not a pure module */